import src from "IMAGE";
export default { src, width: 48, height: 47, blurWidth: 0, blurHeight: 0};
